import documentEditor from 'serviceWorker/services/documents/editDocument';
import { SyncStatus } from 'shared/domain/entitySyncStatus/syncStatus';
import { UploadStatus } from 'shared/types/uploadStatus';

type SetDocumentDrawingUploadStatus = (
    localId: number,
    status: UploadStatus,
    syncStatus: SyncStatus
  ) => Promise<number>;

/** Stores the drawing upload and sync status and broadcasts the document update. */
export const setDocumentDrawingUploadStatus: SetDocumentDrawingUploadStatus =
  async function _setDocumentDrawingUploadStatus(
    localId: number,
    status: UploadStatus,
    syncStatus: SyncStatus
  ): Promise<number> {
    await documentEditor.execute(localId, {
      localId,
      drawingUploadStatus: status,
      drawingSyncStatus: syncStatus,
    });
    return localId;
  };
